export default {
  container: {
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    my: '60px'
  },
  item: {
    flex: '1 1 20%',
    textAlign: 'center',
    borderRight: '1px solid #EAECF0',
    p: '0 16px',
    ':last-of-type': {
      borderRight: 'none', 
    },
    '@media screen and (max-width: 768px)': {
      pb: '20px',
      flex: '1 1 100%', 
      borderRight: 'none',
    },
  },
  percentage: {
    fontSize: '54px',
    fontWeight: 600,
    lineHeight: '72px',
    color: '#0086C9',
    mb: [null, null,null,'12px']
  },
  description: {
    fontSize: '17px',
    fontWeight: 500,
    lineHeight: '28px',
    color: '#101828',
  },
};